import { render, staticRenderFns } from "./sureAccountDialog.vue?vue&type=template&id=1f38c2d2&scoped=true&"
import script from "./sureAccountDialog.vue?vue&type=script&lang=js&"
export * from "./sureAccountDialog.vue?vue&type=script&lang=js&"
import style0 from "./sureAccountDialog.vue?vue&type=style&index=0&id=1f38c2d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38c2d2",
  null
  
)

export default component.exports